import { http } from './config'

export default {
    listar: (data) => {
        // const queryParams = `
        // id=${data.id ? data.id : ''}
        // &cliente=${data.cliente ? data.cliente : ''}
        // &status=${data.status ? data.status : ''}
        // &funcionarioId=${data.funcionarioId ? data.funcionarioId : ''}
        // &data=${data.data ? data.data : ''}
        // &limit=${data.limit ? data.limit : ''}
        // &page=${data.page ? data.page : 1}
        // `
        return http.get(`/v1/orcamentos`, {params: data})
    },
    salvar: (orcamento) => {
        return http.post('/v1/orcamentos', orcamento)
    },
    editar: (id) => {
        return http.get(`/v1/orcamentos/${id}`)
    },
    atualizar: (orcamento) => {
        return http.put(`/v1/orcamentos/${orcamento.id}`, orcamento)
    },
    excluir: (id) => {
        return http.delete(`/v1/orcamentos/${id}`)
    },
    imprimirA4: (id) => {
        return http.get(`/v1/orcamento/${id}/imprimir/a4`)
    },
    imprimirCupom: (id) => {
        return http.get(`/v1/orcamento/${id}/imprimir/cupom`)
    },
    imprimirPropostaA4: (data) => {
        return http.post(`/v1/orcamento/proposta/${data.id}/imprimir/a4`, data.data)
    },
    enviarEmail: (data) => {
        return http.post(`/v1/orcamento/enviar/email`, data)
    },
}